module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Menu","lists":"My lists","gear":"My gear","discover":"Discover","profile":"Profile","settings":"Settings","feedback":"Feedback","logout":"Logout"},"de":{"title":"Menü","lists":"Meine Listen","gear":"Meine Ausrüstung","discover":"Entdecken","profile":"Profil","settings":"Einstellungen","feedback":"Feedback","logout":"Abmelden"}}')
  delete Component.options._Ctor
}
